import type {ReactNode} from 'react';

import {useDndContext} from '@dnd-kit/core';
import classnames from 'classnames';

import styles from './form-editor-dnd-layout.module.css';

export const formEditorDndLayoutStyles = styles;

export function FormEditorDndLayout(props: {children: ReactNode}) {
    const {active} = useDndContext();

    return (
        <div
            className={classnames(styles['scope'], {
                [styles['cursor-grabbing']]: active != null,
            })}
        >
            {props.children}
        </div>
    );
}
